import { useEffect, useState } from 'react';
import { Table, IconTrash, Popup, ButtonSecondary, ButtonSize } from '@ui/src';
import { feesColumns } from '../../../hoc/customers/variables/fees';
import Card from '../card/card';
import { CustomerStatus, FeeItem } from '../../../hoc/customers/types';
import { FeesTypes } from './types';

import cn from './tariffs.module.css';
import cardStyles from '../card/card.module.css';

const Fees = ({
  isLoading,
  values,
  sort,
  onRowsSelect,
  selectedFees,
  showSidepanel,
  onDeleteFees,
  tariff,
  tariffRiskLevel,
  tariffId,
  deleteInProgress,
  deleteSuccess,
  isEditable,
  status,
}: FeesTypes): React.JSX.Element => {
  const [deletePopupVisible, setDeletePopupVisible] = useState(false);

  const selectedFeesNames = values?.filter((item) => {
    const result = selectedFees?.find((id) => item.id === id);

    return result;
  });

  useEffect(() => {
    if (deleteSuccess) {
      setDeletePopupVisible(false);
    }
  }, [deleteSuccess]);

  let popupTitle = 'You want to remove fee?';

  if ((selectedFees?.length as number) > 1) {
    popupTitle = `You want to remove ${selectedFees?.length} fees?`;
  }

  return (
    <>
      <Popup
        title={popupTitle}
        description={selectedFeesNames?.map((item) => item.name).join(', ')}
        onCancelClick={() => setDeletePopupVisible(false)}
        onOkClick={onDeleteFees}
        cancelButtonText="Cancel"
        okButtonText={deleteInProgress ? 'Loading...' : 'Remove'}
        isVisible={deletePopupVisible}
      />
      <Card
        isLoading={isLoading}
        className={`${cardStyles.feesCard} ${!isLoading ? cn.feesCard : ''}`}
      >
        <>
          <div className={cn.tariff}>
            <div>
              {tariff && <div className={cn.tariffTitle}>{tariff}</div>}
              {tariffRiskLevel && (
                <div className={cn.tariffRisk}>
                  Risk category: {tariffRiskLevel}
                </div>
              )}
            </div>
            {isEditable && status !== CustomerStatus.CLOSED && (
              <ButtonSecondary
                size={ButtonSize.SMALL}
                text={tariffId ? 'Change tariff' : 'Assign Tariff'}
                className={cn.changeTariffButton}
                onClick={showSidepanel}
              />
            )}
          </div>
          <div className={cn.feesTop}>
            <div className={cn.feesTitle}>Fees</div>
            {(selectedFees?.length as number) > 0 && (
              <>
                <div className={cn.feesSeparator} />
                <button
                  type="button"
                  className={cn.deleteFeesButton}
                  onClick={() => setDeletePopupVisible(true)}
                >
                  <IconTrash
                    className={cn.deleteFeesButtonIcon}
                    width={16}
                    height={16}
                  />
                  {`Remove fee${
                    (selectedFees?.length as number) > 1 ? 's' : ''
                  }`}
                </button>
              </>
            )}
          </div>
          <div className={cn.feesTableWrapper}>
            {!tariffId && (
              <div className={cn.assignTariffMessage}>Assign Tariff</div>
            )}
            <Table
              columns={feesColumns}
              data={(values as FeeItem[]) || []}
              onSort={() => {}}
              filters={{}}
              sort={sort}
              tableClassName={!values?.length ? cn.feesTable : ''}
              columnsLabels={{}}
              onFilterChange={() => {}}
              onRowsSelect={isEditable ? onRowsSelect : undefined}
              tableBodyClassName={`${cn.feesTableBody} ${
                !tariffId ? cn.feesEmptyTable : ''
              }`}
              disabledRowIds={values
                ?.filter((item) => !item.isModified)
                ?.map((item) => item.id)}
              clearSelectedItems={deleteSuccess}
              clickable
            />
          </div>
        </>
      </Card>
    </>
  );
};

export default Fees;
